import { Tooltip, Typography } from 'src/components/common';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';
import Button from 'src/components/button/Button';
import { textEllipsis } from 'src/utils';

import './addEvaluator.scss';
import Entrepreneur from 'src/assets/images/svg/Entrepreneur.svg';
import MentorBadge from 'src/assets/images/svg/MentorBadge.svg';

export type TAddEvaluatorProps = {
  profilePic: string;
  name: string;
  role: string;
  email: string;
  handleAddUser: () => void;
  alreadyAdded: boolean;
};

const AddEvaluator = ({
  profilePic,
  name = '',
  role = '',
  email = '',
  handleAddUser,
  alreadyAdded
}: TAddEvaluatorProps) => {
  const nameEllipsis = textEllipsis({ charLimit: 12, text: name });
  const emailEllipsis = textEllipsis({ charLimit: 18, text: email });

  return (
    <div className="add-evaluator">
      <div className="add-evaluator__user-info">
        <ProfilePicture
          url={profilePic}
          fallback={name[0]}
          className="add-evaluator__user-info__profile-pic"
        />
        <div className="add-evaluator__user-info__user">
          <div className="add-evaluator__user-info__user__row">
            <Tooltip text={name} conditionToDisplay={nameEllipsis?.hasEllipsis} limitWidth>
              <Typography
                as="span"
                variant="body-2"
                fontWeight="semiBold"
                className="add-evaluator__user-info__user__row__name"
              >
                {nameEllipsis?.text}
                {(role === "Aspiring Entrepreneur" || role === "Entrepreneur") && (<img style={{ marginLeft: '8px', height: '20px', width: '20px' }} src={Entrepreneur} alt="  Entrepreneur" />)}
                {(role === "Mentor" || role === "Investor") && (<img style={{ marginLeft: '8px', height: '18px', width: '18px' }} src={MentorBadge} alt="Mentor/Investor" />)}
              </Typography>
            </Tooltip>
            <hr></hr>
            <Typography
              as="span"
              variant="caption"
              fontWeight="regular"
              className="add-evaluator__user-info__user__row__role"
            >
              {role}
            </Typography>
          </div>
          <Tooltip text={email} conditionToDisplay={emailEllipsis?.hasEllipsis} limitWidth>
            <Typography
              as="p"
              variant="caption"
              fontWeight="regular"
              className="add-evaluator__user-info__user__row__email"
            >
              {emailEllipsis?.text}
            </Typography>
          </Tooltip>
        </div>
      </div>
      <Button
        variant={alreadyAdded ? 'tertiary' : 'secondary'}
        size="extraSmall"
        className="add-evaluator__action"
        onClick={handleAddUser}
      >
        {alreadyAdded ? 'Remove' : 'Add'}
      </Button>
    </div>
  );
};

export default AddEvaluator;
